import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import { observer } from 'mobx-react'
import { hashHistory } from 'react-router'
import style from './style.module.less'
import {
  PROPERTY_WEDDING_PHOTO_ID,
  CHOOSE_WEDDING_PHOTO_PATH,
  PUBLISH_MEAL_PATH_A,
  PRIVILEGE_STORE_ID,
  PRIVILEGE_STORE_SERVICE_ID
} from '@constant'
import { Auth } from '@common/Auth'
import cls from 'classnames'

class Property extends Component {
  onClick = () => {
    if (this.props.id == PROPERTY_WEDDING_PHOTO_ID) {
      hashHistory.push(CHOOSE_WEDDING_PHOTO_PATH)
    } else {
      window.location.href = `${PUBLISH_MEAL_PATH_A}?propertyId=${
        this.props.id
      }`
    }
  }

  render() {
    const { image, name } = this.props

    return (
      <div className={style.item} onClick={this.onClick}>
        <img src={image} />
        <p>{name}</p>
      </div>
    )
  }
}

@Auth({ role: [PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID] })
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store(0)
  }

  componentDidMount() {
    this.store.getPropertyList()
  }

  render() {
    const { propertyList } = this.store

    return (
      <HeaderView title="发布套餐">
        <div className={style.header}>选择类目</div>
        <div className={cls('clearfix', style.list)}>
          {propertyList.map(item => <Property key={item.id} {...item} />)}
        </div>
      </HeaderView>
    )
  }
}
